const strings = {
  en: {
    translation: {
      chat_messages_empty: 'There are no messages in the chat',
      chat_textarea_placeholder: 'Enter Message Here',
      avatar_card_edit: 'Edit',
      avatar_card_save: 'Save',
      avatar_card_cancel: 'Cancel',
      cobrowse_invite_title: 'Start a Co-Shopping Session',
      cobrowse_invite_subtitle:
        'Explore, discover and shop with others in real time.',
      cobrowse_schedule_session: 'Create a Co-Shopping Session',
      cobrowse_schedule_session_subtext:
        'Explore, discover and shop with others in real time.',
      cobrowse_send_schedule_session: 'Co-Shopping Session Created',
      cobrowse_send_schedule_session_subtext:
        'Send your invite to your client(s).',
      cobrowse_create_session_buttontext: 'CREATE SESSION',
      cobrowse_share_email_header: 'Share Via Email',
      cobrowse_share_email_placeholder: 'Email Address..',
      cobrowse_share_email_instructions: '(Use commas for multiple addresses)',
      cobrowse_share_email_buttontext: 'SEND INVITE',
      cobrowse_share_calendar_header: 'Share via Calendar',
      cobrowse_share_link_header: 'Copy Invite Link',
      cobrowse_share_link_buttontext: 'COPY TO CLIPBOARD',
      cobrowse_about_coshopping_title: 'About Co-Shopping',
      cobrowse_empty_peers_list:
        'There are no other peers currently in your session',
      cobrowse_teleport_prompt: 'Teleport To Shopper',
      cobrowse_follow_prompt: 'Auto Follow Shopper',
      cobrowse_detach_prompt: 'Detach From Shopper',
      cobrowse_session_created_title: 'Co-Shopping Session Created',
      cobrowse_session_created_subtext:
        'Send the invite link to people you would like to join you. You will be notified as soon as they join.',
      cobrowse_share_social_prompt: 'Share Via Social',
      cobrowse_avatar_title: 'Your Avatar',
      cobrowse_connection_failed_notification:
        'Connection failed, CoShopping is unavailable',
      cobrowse_join_failed_notification:
        'Join CoShopping failed, return to normal session',
      iteminfo_card_details_button: 'Details',
      iteminfo_card_remove_button: 'Remove',
      iteminfo_card_save_button: 'Save',
      iteminfo_card_cart_button: 'Add to cart',
      menu_search_store: 'Search / Directory',
      menu_cart: 'Your Cart',
      menu_saved_items: 'Saved Items',
      menu_request_help: 'Request Help',
      menu_request_help_desc:
        'Get remote help from an expert who will join your session!',
      menu_audio_controls: 'Audio Controls',
      menu_settings: 'Settings',
      menu_share: 'Share Showroom',
      music: 'Music',
      audio_beacons: 'Audio Beacons',
      language: 'Language',
      currency: 'Currency',
      english: 'English',
      french: 'French',
      menu_accociate_schedule: 'Schedule a cobrowsing session',
      loading_text: 'Loading Virtual Experience...',
      loading_enter_text: 'enter',
      loading_coshopper_waiting:
        'Your co-shopper(s) is waiting for you in the showroom.',
      loading_cobrowser_name_input_placeholder: 'Nickname',
      loading_callout_1: 'View Products In Your Home',
      loading_callout_2: 'Hear Audio Descriptions',
      loading_callout_3: 'Shop Remotely With Friends!',
      loading_callout_4: 'Add Items To Cart',
      enter_name: '*Enter name',
      enter_email: '*Enter email address',
      require_vaild_name: 'Require a name',
      require_vaild_email: 'Please enter a valid email address',
      title: 'You have',
      save_item_end: 'saved items:',
      cart_item_end: 'items in your cart:',
      proceed_check_out: 'PROCEED TO CHECKOUT',
      cart_title: 'Cart Summary',
      saved_item_title: 'Saved Items',
      toolbar_tooltip_menu: 'Menu',
      toolbar_tooltip_cb_exit: 'Exit CoShopping',
      toolbar_tooltip_search: 'Search Items',
      toolbar_tooltip_coshoppers: 'CoShoppers',
      toolbar_tooltip_chat: 'Chat',
      menu_help_title: 'Help Tutorial',
      menu_help_text:
        'See how to get the full virtual experience: navigating the space, selecting items, inspecting products and more.',
      menu_coshopping_title: 'Co-Browsing',
      menu_coshopping_text:
        'Invite others to join you in the virtual experience to explore together.',
      search_placeholder_text: 'What are you looking for?',
      search_no_results: 'No Results',
      search_no_results_empty_message:
        'No Results. Try Searching Something - Ex: "Sofa"',
      teleport_confirm: 'Are you sure to teleport',
      go_to_item: 'GO TO ITEM',
      view_full_detail: 'ENLARGE / VIEW FULL DETAILS',
      in_follow_mode: 'Currently In Follow Mode',
      search_more_showrooms_title: 'More Showrooms',
      search_more_showrooms: 'More items found in other showrooms:',
      cobrowse_chat_start_message_standard:
        'Your CoShopping session is created. Open the CoShopping panel located in the toolbar at the top of your screen to copy the link and invite friends to explore the space!',
      cobrowse_chat_start_message_scheduled:
        'Welcome to your Virtual Design Center session. Your designer will be here soon. You are free to explore the VDC while you wait. Once connected, you will be able to chat and speak with your designer via microphone.',
      cobrowse_chat_start_message_scheduled_host:
        'Welcome to your Virtual Design Center session. Your client will be here soon. You are free to explore the VDC while you wait. Once connected, you will be able to chat and speak with your client via microphone.',
      cobrowse_schedule_join_session_button: 'Join',
      cobrowse_schedule_join_session_header: 'Join Scheduled Session Now',
      cobrowse_session_created: 'Co-Shopping Session Created',
      cobrowse_feature_title_expore: 'Explore',
      cobrowse_feature_content_expore:
        'Explore and shop the space with one, or multiple people.',
      cobrowse_feature_title_shop: 'Shop',
      cobrowse_feature_content_shop:
        'Save products to a shared co-shopper cart.',
      cobrowse_feature_title_voice: 'Voice',
      cobrowse_feature_content_voice:
        'Use your device’s microphone and audio to converse with all your co-shoppers.',
      cobrowse_feature_title_chat: 'Chat',
      cobrowse_feature_content_chat: 'Chat with your cobrowsers.',
      cobrowse_feature_title_pair: 'Pair',
      cobrowse_feature_content_pair:
        'Pair (or link) with a shopper to see exactly what they are seeing.',
      exist_experience: 'Exit Experience',
      saved_items_email_list_header: 'Email Saved Items List',
      toolbar_mute_microphone: 'Mute Microphone',
      toolbar_unmute_microphone: 'Unmute Microphone',
      menu_more_spaces: 'Explore More Spaces',
      toolbar_tooltip_cart: 'Cart',
      toolbar_tooltip_saved_items: 'Saved Items',
      current_session: 'Current Session',
      your_co_shoppers: 'Your Co-shoppers',
      go_to_this_space: 'Go To This Space',
      shopper: 'Shopper',
      dimention: 'Dimensions',
      save_button: 'Save',
      share_button: 'Share',
      email_sent: 'Email Sent',
      no_saved_items: 'No Saved Items',
      item_saved: 'Item Saved',
      item_removed: 'Item Removed',
      link_in_chat_button: 'Link in Chat',
      out_of_stock: 'This item is out of stock',
      error_fetch_associate_id: 'Error Fetching Associate Id',
      copy_to_clipboard: 'COPY INVITE LINK TO CLIPBOARD',
      joystick_move_notification: 'DRAG UP/DOWN TO MOVE',
      joystick_drag_notification: 'DRAG LEFT/RIGHT TO ROTATE',
      product_link_copy_notificcation: 'Product Link Copied to Clipboard',
      cb_session_creat_notification: 'CoBrowsing Session Created',
      cb_invite_notification: 'Invitation Sent',
      cb_link_copied_notification: 'CoShopping link copied to clipboard',
      cb_connect_notification: 'Connecting to CoShopping',
      cb_in_follow_notification: 'Currently in follow mode',
      quanity: 'Quanity',
      cart_is_empty: 'Cart Is Empty',
      tutorial_start_message:
        'The tutorial starts, following the steps or using the close button to exit the tutorial',
      tutorial_step_1_desktop: 'Press and drag to look around.',
      tutorial_step_2_desktop: 'Double-click the floor to move around.',
      tutorial_step_3_desktop: 'Click on any product for a closer look.',
      tutorial_step_4_desktop:
        'Click the details button to further inspect a product.',
      tutorial_step_5_desktop: 'View products in 3D, AR and more.',
      tutorial_step_6_desktop:
        'Share the invite with remote friends to explore the space together!',
      tutorial_step_7_desktop: 'Use search to quicky locate products',
      tutorial_step_8_desktop:
        'Use the keyboard to move. Click products to view detail and teleport',
      tutorial_step_1_mobile: 'Drag to look around.',
      tutorial_step_2_mobile: 'Double tap the floor to move around.',
      tutorial_step_3_mobile: 'Tap on any product for a closer look.',
      tutorial_step_4_mobile: 'Tap details to inspect product.',
      tutorial_step_5_mobile: 'View in 3D, AR and more.',
      tutorial_step_6_mobile:
        'Share the invite with remote friends to explore the space together!',
      tutorial_step_7_mobile: 'Use search to quicky locate products',
      tutorial_step_8_mobile:
        'Single tap the ground to move. Tap products to view detail and teleport',
      tutorial_button_disabled_tip: 'please complete or close tutorial',
      view_detail_button: 'VIEW DETAILS',
      bitstream_status_pause: 'paused',
      bitstream_status_unpause: 'unpaused',
      bitstream_status_loading: 'loading',
      bitstream_status_idle: 'idle',
      turkish: 'Turkish',
      load_product_area: 'Loading Product Area...',
      view_in_your_home_text: 'View In Your Home (AR)',
      pause_viewer_text: 'Paused - Focus the tab/window to continue',
      cb_audio_fail_notification: 'Error connecting to audio',
      cb_joined_the_session: 'Joined the CoShopping Session',
      cb_left_the_session: 'Left the CoShopping Session',
      added_to_cart: 'Added To Cart',
      added_item_to_cart: 'added this item to cart',
      removed_item_from_cart: 'removed this item from cart',
      item_out_of_stock: 'This item is out of stock',
      saved_item: 'saved the item',
      removed_item: 'removed the item',
      initiate_request_help_message:
        'Checking to see if someone is available to help, please wait...',
      request_help_failed:
        'Sorry, no one is available to help right now. Please explore the space and try again at a later time.',
      request_help_success:
        'Got it! Someone will be joining your CoShopping session within 3 minutes',
      request_help_pending_menu_text:
        'Help Requested. Someone will join you in the next few minutes',
      request_help_failed_menu_text:
        'Sorry, no experts are available now, please try again',
      request_help_taking_time:
        'Sorry, your designer is busier than expected right now. Please continue to wait or some back another time.',
      request_help_arrived:
        'Thanks for waiting, someone is connecting now to assist you',
      cb_session_full: 'Sorry this session is full',
      cb_session_full_tooltip: 'The session is full',
    },
  },
  tr: {
    translation: {
      chat_messages_empty: 'Sohbette mesaj yok',
      chat_textarea_placeholder: 'Buraya Mesajınızı Girin',
      avatar_card_edit: 'Düzenle',
      avatar_card_save: 'Kaydet',
      avatar_card_cancel: 'İptal',
      cobrowse_invite_title: 'Ortak Alışveriş Oturumu Başlatın',
      cobrowse_invite_subtitle:
        'Eş zamanlı olarak başkalarıyla keşfedin ve alışveriş yapın',
      cobrowse_schedule_session: 'Ortak Alışveriş Oturumu Oluşturun',
      cobrowse_schedule_session_subtext:
        'Eş zamanlı olarak başkalarıyla keşfedin ve alışveriş yapın',
      cobrowse_send_schedule_session: 'Ortak Alışveriş Oturumu Oluşturuldu',
      cobrowse_send_schedule_session_subtext:
        'Davetinizi müşterilerinize gönderin',
      cobrowse_create_session_buttontext: 'OTURUM OLUŞTUR',
      cobrowse_share_email_header: 'E-posta ile Paylaş',
      cobrowse_share_email_placeholder: 'E-posta Adresi',
      cobrowse_share_email_instructions:
        '(Birden fazla adres için virgül kullanın)',
      cobrowse_share_email_buttontext: 'DAVET GÖNDER',
      cobrowse_share_calendar_header: 'Calendar ile Paylaş',
      cobrowse_share_link_header: 'Davet Bağlantısını Kopyala',
      cobrowse_share_link_buttontext: 'PANOYA KOPYALA',
      cobrowse_about_coshopping_title: 'Ortak Alışveriş Hakkında',
      cobrowse_empty_peers_list: 'Şu anda oturumunuzda başka kullanıcı yok',
      cobrowse_teleport_prompt: "Shopper'a Git",
      cobrowse_follow_prompt: "Shopper'ı Otomatik Takip Et",
      cobrowse_detach_prompt: 'Ortak Alışveriş Oturumu Oluşturuldu',
      cobrowse_session_created_title: 'Ortak Alışveriş Oturumu Oluşturuldu',
      cobrowse_session_created_subtext:
        'Katılmasını istediğiniz kişilere davet bağlantısı gönderin. Katıldıklarında bilgilendirileceksiniz',
      cobrowse_share_social_prompt: 'Social Üzerinden Paylaş',
      cobrowse_avatar_title: 'Avatarınız',
      cobrowse_connection_failed_notification:
        'Bağlantı Başarısız, ortak alışveriş kullanılamıyor',
      cobrowse_join_failed_notification:
        'Ortak alışverişe katılma başarısız oldu, normal oturuma dönün',
      iteminfo_card_details_button: 'Ayrıntılar',
      iteminfo_card_remove_button: 'Kaldır',
      iteminfo_card_save_button: 'Kaydet',
      iteminfo_card_cart_button: 'Sepete Ekle',
      menu_search_store: 'Arama / Mağaza Dizini (devre dışı)',
      menu_cart: 'Sepetiniz',
      menu_saved_items: 'Kaydedilenler',
      menu_audio_controls: 'Ses Kontrolü',
      menu_settings: 'Ayarlar',
      menu_share: "Showroom'u Paylaş",
      music: 'Müzik',
      audio_beacons: 'Ses İşaretleri',
      language: 'Dil',
      currency: 'Para Birimi',
      english: 'İngilizce',
      french: 'Fransızca',
      menu_accociate_schedule: 'Eş zamanlı arama oturumu planla',
      loading_text: 'Sanal Deneyim Yükleniyor...',
      loading_enter_text: 'Giriş',
      loading_coshopper_waiting:
        "Alışveriş ortaklarınız Showroom'da sizi bekliyor",
      loading_cobrowser_name_input_placeholder: 'Rumuz',
      loading_callout_1: 'Ürünleri Anasayfada Görüntüle',
      loading_callout_2: 'Sesli Açıklamaları Dinle',
      loading_callout_3: 'Arkadaşlarınızla Uzaktan Alışveriş Yapın!',
      loading_callout_4: 'Ürünleri Sepete Ekle',
      enter_name: '*İsim girin',
      enter_email: '*E-posta adresi girin',
      require_vaild_name: 'İsim gerekli',
      require_vaild_email: 'Lütfen geçerli bir e-posta adresi girin',
      title: 'Kayıtlı',
      save_item_end: 'ürünleriniz var :',
      cart_item_end: 'sepetinizdeki ürünler :',
      proceed_check_out: 'ÖDEMEYE İLERLE',
      cart_title: 'Sepet Özeti',
      saved_item_title: 'Kaydedilenler',
      toolbar_tooltip_menu: 'Menü',
      toolbar_tooltip_search: 'Ürünleri Ara',
      toolbar_tooltip_coshoppers: 'Ortak Alışveriş Yapanlar',
      toolbar_tooltip_chat: 'Sohbet',
      menu_help_title: 'Yardım Eğitimi',
      menu_help_text:
        'Tam sanal deneyimi nasıl yaşayacağınızı görün : Alanda gezinme, ürün seçme, ürünleri inceleme ve daha fazlası',
      menu_coshopping_title: 'Ortak Alışveriş',
      menu_coshopping_text:
        'Birlikte keşfetmek ve alışveriş yapmak için başkalarını sanal deneyimde size katılmaya davet edin',
      search_placeholder_text: 'Ne arıyorsunuz?',
      search_no_results: 'Sonuç Yok',
      search_no_results_empty_message:
        'Sonuç Yok. Bir Şey Aramayı Deneyin. Örn: "Kanepe"',
      search_more_showrooms_title: 'Daha Fazla Showroom',
      search_more_showrooms: "Diğer Showroom'larda daha fazla ürün bulundu",
      cobrowse_chat_start_message_standard:
        'CoShopping oturumunuz oluşturuldu. Bağlantıyı kopyalamak ve arkadaşlarınızı alanı keşfetmeye davet etmek için ekranınızın üst kısmındaki araç çubuğunda bulunan CoShopping panelini açın!',
      cobrowse_chat_start_message_scheduled:
        "Sanal Tasarım Merkezi oturumunuza hoş geldiniz. Tasarımcınız yakında burada olacak. Beklerken özgürce VDC'yi keşfedebilirsiniz. Bağlandıktan sonra tasarımcınızla mikrofon üzerinden sohbet edebilecek ve konuşabileceksiniz.",
      cobrowse_schedule_join_session_button: 'Katıl',
      cobrowse_schedule_join_session_header: 'Şimdi Planlanmış Oturuma Katılın',
      cobrowse_session_created: 'Co-Shopping Oturumu Oluşturuldu',
      cobrowse_feature_title_expore: 'Keşfet',
      cobrowse_feature_content_expore:
        'Alanda bir veya daha fazla kişiyle keşif ve alışveriş yapın.',
      cobrowse_feature_title_shop: 'Alışveriş Yap',
      cobrowse_feature_content_shop:
        'Ürünleri ortak co-shopping sepetine kaydedin.',
      cobrowse_feature_title_voice: 'Konuş',
      cobrowse_feature_content_voice:
        'Tüm alışveriş arkadaşlarınızla sohbet etmek için cihazınızın mikrofonunu ve sesini kullanın.',
      cobrowse_feature_title_chat: 'Sohbet Et',
      cobrowse_feature_content_chat: 'Oturumdaki kişilerle sohbet edin.',
      cobrowse_feature_title_pair: 'Eşleş',
      cobrowse_feature_content_pair:
        'Onların gözünden görmek için alışveriş yapan başka biriyle eşleşin (veya bağlantı kurun).',
      exist_experience: 'Deneyimden Çık',
      saved_items_email_list_header:
        'Kayıtlı Ürünler Listesini E-posta olarak gönder',
      toolbar_mute_microphone: 'Mikrofonu Kapat',
      toolbar_unmute_microphone: 'Mikrofonu Aç',
      menu_more_spaces: 'Daha Fazla Alan Keşfet',
      toolbar_tooltip_cart: 'Sepet',
      toolbar_tooltip_saved_items: 'Kaydedilenler',
      current_session: 'Şimdiki Oturum',
      your_co_shoppers: 'Sizinle Alışveriş Yapan Kişiler',
      go_to_this_space: 'Bu Alana Git',
      shopper: 'Alışverişçi',
      dimention: 'Boyutlar',
      save_button: 'Kaydet',
      share_button: 'Paylaş',
      email_sent: 'E-posta Gönderildi',
      no_saved_items: 'Kaydedilen Ürün Yok',
      item_saved: 'Ürün Kaydedildi',
      item_removed: 'Ürün Kaldırıldı',
      link_in_chat_button: 'Bağlantıyı Sohbette Paylaş',
      out_of_stock: 'Bu üründen stokta mevcut değil',
      error_fetch_associate_id:
        'İlişkilendirilen Kimlik Getirilirken Hata Oluştu',
      copy_to_clipboard: 'DAVET BAĞLANTISINI PANOYA KOPYALAYIN',
      joystick_move_notification: 'TAŞIMAK İÇİN YUKARI/AŞAĞI SÜRÜKLEYİN',
      joystick_drag_notification: 'DÖNDÜRMEK İÇİN SAĞA/SOLA SÜRÜKLEYİN',
      product_link_copy_notificcation: 'Ürün Bağlantısı Panoya Kopyalandı',
      cb_session_creat_notification: 'Ortak Browser Oturumu Oluşturuldu',
      cb_invite_notification: 'Davet Gönderildi',
      cb_link_copied_notification: 'CoShopping bağlantısı panoya kopyalandı',
      cb_connect_notification: "CoShopping'e bağlanılıyor",
      cb_in_follow_notification: 'Şu anda takip modunda',
      quanity: 'Miktar',
      cart_is_empty: 'Sepet boş',
      tutorial_start_message:
        'Eğitim başlıyor , adımları takip edin veya eğitimden çıkmak için kapat düğmesini kullanın',
      tutorial_step_1_desktop: 'Etrafa bakmak için basın ve sürükleyin.',
      tutorial_step_2_desktop: 'Hareket etmek için zemine çift tıklayın.',
      tutorial_step_3_desktop:
        'Yakından incelemek istediğiniz bir ürüne tıklayın.',
      tutorial_step_4_desktop: 'Ürünü incelemek için ayrıntılara tıklayın.',
      tutorial_step_5_desktop:
        'Ürünleri 3D, AR ve daha fazlasında görüntüleyin.',
      tutorial_step_6_desktop:
        'Birlikte keşfetmek ve alışveriş yapmak için arkadaşlarınızı sanal deneyimde size katılmaya davet edin',
      tutorial_step_7_desktop: 'Ürünleri hızlıca bulmak için aramayı kullanın',
      tutorial_step_8_desktop:
        'Hareket etmek için klavyeyi kullanın. Ürün detayları görüntülemek ve hızlı hareket etmek için ürünlere tıklayın',
      tutorial_step_1_mobile: 'Etrafa bakmak için sürükleyin.',
      tutorial_step_2_mobile: 'Hareket etmek için yere iki kez dokunun.',
      tutorial_step_3_mobile:
        'Yakından incelemek istediğniz bir ürüne dokunun.',
      tutorial_step_4_mobile: 'Ürünü incelemek için ayrıntılara dokunun.',
      tutorial_step_5_mobile: '3D, AR ve daha fazlasını görüntüleyin.',
      tutorial_step_6_mobile:
        'Birlikte keşfetmek ve alışveriş yapmak için arkadaşlarınızı sanal deneyimde size katılmaya davet edin',
      tutorial_step_7_mobile: 'Ürünleri hızlıca bulmak için aramayı kullanın',
      tutorial_step_8_mobile:
        'Hareket etmek için zemine bir kere dokunun. Ürün detaylarını görmek ve hızlı hareket etmek için ürünlere dokunun',
      tutorial_button_disabled_tip:
        'Lütfen eğitime devam edin ya da sonlandırın',
      view_detail_button: 'DETAYLARI GÖSTER',
      bitstream_status_pause: 'duraklatıldı',
      bitstream_status_unpause: 'devam ediyor',
      bitstream_status_loading: 'yükleniyor',
      bitstream_status_idle: 'devam ediyor',
      turkish: 'Türkçe',
      load_product_area: 'Ürün Alanına Gidiliyor...',
      view_in_your_home_text: 'Evinde Görüntüle (AR)',
      pause_viewer_text:
        'Duraklatıldı - Devam etmek için sekmeye/pencereye odaklanın',
      cb_audio_fail_notification: 'Error connecting to audio',
      cb_joined_the_session: 'Joined the CoShopping Session',
      cb_left_the_session: 'Left the CoShopping Session',
      added_to_cart: 'Sepete Eklendi',
      added_item_to_cart: 'bu ürünü sepete ekledi',
      removed_item_from_cart: 'bu ürünü sepetten çıkardı',
      item_out_of_stock: 'Bu ürün stokta yok',
      saved_item: 'bu ürünü kaydetti',
      removed_item: 'bu ürünü kaldırdı',
    },
  },
  fr: {},
};

export default strings;
